const Navlinks = [
  {
    title: "Home",
    link: "home",
  },
  {
    title: "About",
    link: "about",
  },
  {
    title: "Skills",
    link: "skills",
  },
  {
    title: "Projects",
    link: "projects",
  },
    {
  title: "Certifications",
  link: "certifications" 
 },
  {
    title: "Experience",
    link: "experience",
  },
  {
    title: "Contact",
    link: "contact",
  },
];

export default Navlinks;
